var _desc, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckmarkUnchecked(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100px",
    height: "100px",
    viewBox: "0 0 100 100",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "checkmarkUncheckedV2") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "6.-Materialen",
    transform: "translate(-260.000000, -651.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Check-button",
    transform: "translate(263.000000, 654.000000)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval-13",
    stroke: "#969BA7",
    strokeWidth: 5,
    cx: 47.0522908,
    cy: 47.0522908,
    r: 47.0522908
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Path-259",
    stroke: "#9197A3",
    strokeWidth: 6,
    points: "17.878842 41.1776242 38.5662965 66.260497 76.6992473 29.5290914"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckmarkUnchecked);
export default __webpack_public_path__ + "static/media/checkmarkUnchecked.0075d7c3866e6fc640de34ce466de9dd.svg";
export { ForwardRef as ReactComponent };